import {    pro5F1Charge,pro5F1Payment,pro5F1Collectable,pro5F1NonCollectable,pro5F1ClaimCount,pro5F1PerVisit,
    pro5F2Charge,pro5F2Payment,pro5F2Collectable,pro5F2NonCollectable,pro5F2ClaimCount,pro5F2PerVisit,
    pro5F3Charge,pro5F3Payment,pro5F3Collectable,pro5F3NonCollectable,pro5F3ClaimCount,pro5F3PerVisit,} from './FacilityData';



import {provider5PerVisist} from './ProvidersAndFacility';


export const pro5WithJan21Charges = [
    pro5F1Charge.jan21,
    pro5F2Charge.jan21,
    pro5F3Charge.jan21,
    pro5F1Charge.jan21 + pro5F2Charge.jan21 + pro5F3Charge.jan21

]
// console.log("pro5WithJan21Charges :",pro5WithJan21Charges)
export const pro5WithJan21Pay = [
    pro5F1Payment.jan21,
    pro5F2Payment.jan21,
    pro5F3Payment.jan21,
    pro5F1Payment.jan21 + pro5F2Payment.jan21 + pro5F3Payment.jan21
]
export const pro5WithJan21Count = [
    pro5F1Collectable.jan21,
    pro5F2Collectable.jan21,
    pro5F3Collectable.jan21,
    pro5F1Collectable.jan21 + pro5F2Collectable.jan21 + pro5F3Collectable.jan21
]
export const pro5WithJan21NonCount = [
    pro5F1NonCollectable.jan21,
    pro5F2NonCollectable.jan21,
    pro5F3NonCollectable.jan21,
    pro5F1NonCollectable.jan21 + pro5F2NonCollectable.jan21 + pro5F3NonCollectable.jan21
]
export const pro5WithJan21Claim = [
    pro5F1ClaimCount.jan21,
    pro5F2ClaimCount.jan21,
    pro5F3ClaimCount.jan21,
    pro5F1ClaimCount.jan21 + pro5F2ClaimCount.jan21 + pro5F3ClaimCount.jan21
]
export const pro5WithJan21PerVisit = [
    pro5F1PerVisit.jan21,
    pro5F2PerVisit.jan21,
    pro5F3PerVisit.jan21,
    provider5PerVisist[0]
]
// feb 21
export const pro5WithFeb21Charges = [
    pro5F1Charge.feb21,
    pro5F2Charge.feb21,
    pro5F3Charge.feb21,
    pro5F1Charge.feb21 + pro5F2Charge.feb21 + pro5F3Charge.feb21
]
export const pro5WithFeb21Pay = [
    pro5F1Payment.feb21,
    pro5F2Payment.feb21,
    pro5F3Payment.feb21,
    pro5F1Payment.feb21 + pro5F2Payment.feb21 + pro5F3Payment.feb21
]
export const pro5WithFeb21Count = [
    pro5F1Collectable.feb21,
    pro5F2Collectable.feb21,
    pro5F3Collectable.feb21,
    pro5F1Collectable.feb21 + pro5F2Collectable.feb21 + pro5F3Collectable.feb21
]
export const pro5WithFeb21NonCount = [
    pro5F1NonCollectable.feb21,
    pro5F2NonCollectable.feb21,
    pro5F3NonCollectable.feb21,
    pro5F1NonCollectable.feb21 + pro5F2NonCollectable.feb21 + pro5F3NonCollectable.feb21
]
export const pro5WithFeb21Claim = [
    pro5F1ClaimCount.feb21,
    pro5F2ClaimCount.feb21,
    pro5F3ClaimCount.feb21,
    pro5F1ClaimCount.feb21 + pro5F2ClaimCount.feb21 + pro5F3ClaimCount.feb21
]
export const pro5WithFeb21PerVisit = [
    pro5F1PerVisit.feb21,
    pro5F2PerVisit.feb21,
    pro5F3PerVisit.feb21,
    provider5PerVisist[1]
]
// mar 21
export const pro5WithMar21Charges = [
    pro5F1Charge.mar21,
    pro5F2Charge.mar21,
    pro5F3Charge.mar21,
    pro5F1Charge.mar21 + pro5F2Charge.mar21 + pro5F3Charge.mar21
]
export const pro5WithMar21Pay = [
    pro5F1Payment.mar21,
    pro5F2Payment.mar21,
    pro5F3Payment.mar21,
    pro5F1Payment.mar21 + pro5F2Payment.mar21 + pro5F3Payment.mar21
]
export const pro5WithMar21Count = [
    pro5F1Collectable.mar21,
    pro5F2Collectable.mar21,
    pro5F3Collectable.mar21,
    pro5F1Collectable.mar21 + pro5F2Collectable.mar21 + pro5F3Collectable.mar21
]
export const pro5WithMar21NonCount = [
    pro5F1NonCollectable.mar21,
    pro5F2NonCollectable.mar21,
    pro5F3NonCollectable.mar21,
    pro5F1NonCollectable.mar21 + pro5F2NonCollectable.mar21 + pro5F3NonCollectable.mar21
]
export const pro5WithMar21Claim = [
    pro5F1ClaimCount.mar21,
    pro5F2ClaimCount.mar21,
    pro5F3ClaimCount.mar21,
    pro5F1ClaimCount.mar21 + pro5F2ClaimCount.mar21 + pro5F3ClaimCount.mar21
]
export const pro5WithMar21PerVisit = [
    pro5F1PerVisit.mar21,
    pro5F2PerVisit.mar21,
    pro5F3PerVisit.mar21,
    provider5PerVisist[2]
]
// april 21
export const pro5WithApr21Charges = [
    pro5F1Charge.apr21,
    pro5F2Charge.apr21,
    pro5F3Charge.apr21,
    pro5F1Charge.apr21 + pro5F2Charge.apr21 + pro5F3Charge.apr21
]
export const pro5WithApr21Pay = [
    pro5F1Payment.apr21,
    pro5F2Payment.apr21,
    pro5F3Payment.apr21,
    pro5F1Payment.apr21 + pro5F2Payment.apr21 + pro5F3Payment.apr21
]
export const pro5WithApr21Count = [
    pro5F1Collectable.apr21,
    pro5F2Collectable.apr21,
    pro5F3Collectable.apr21,
    pro5F1Collectable.apr21 + pro5F2Collectable.apr21 + pro5F3Collectable.apr21
]
export const pro5WithApr21NonCount = [
    pro5F1NonCollectable.apr21,
    pro5F2NonCollectable.apr21,
    pro5F3NonCollectable.apr21,
    pro5F1NonCollectable.apr21 + pro5F2NonCollectable.apr21 + pro5F3NonCollectable.apr21
]
export const pro5WithApr21Claim = [
    pro5F1ClaimCount.apr21,
    pro5F2ClaimCount.apr21,
    pro5F3ClaimCount.apr21,
    pro5F1ClaimCount.apr21 + pro5F2ClaimCount.apr21 + pro5F3ClaimCount.apr21
]
export const pro5WithApr21PerVisit = [
    pro5F1PerVisit.apr21,
    pro5F2PerVisit.apr21,
    pro5F3PerVisit.apr21,
    provider5PerVisist[3]
]
// may 21
export const pro5WithMay21Charges = [
    pro5F1Charge.may21,
    pro5F2Charge.may21,
    pro5F3Charge.may21,
    pro5F1Charge.may21 + pro5F2Charge.may21 + pro5F3Charge.may21
]
export const pro5WithMay21Pay = [
    pro5F1Payment.may21,
    pro5F2Payment.may21,
    pro5F3Payment.may21,
    pro5F1Payment.may21 + pro5F2Payment.may21 + pro5F3Payment.may21
]
export const pro5WithMay21Count = [
    pro5F1Collectable.may21,
    pro5F2Collectable.may21,
    pro5F3Collectable.may21,
    pro5F1Collectable.may21 + pro5F2Collectable.may21 + pro5F3Collectable.may21
]
export const pro5WithMay21NonCount = [
    pro5F1NonCollectable.may21,
    pro5F2NonCollectable.may21,
    pro5F3NonCollectable.may21,
    pro5F1NonCollectable.may21 + pro5F2NonCollectable.may21 + pro5F3NonCollectable.may21
]
export const pro5WithMay21Claim = [
    pro5F1ClaimCount.may21,
    pro5F2ClaimCount.may21,
    pro5F3ClaimCount.may21,
    pro5F1ClaimCount.may21 + pro5F2ClaimCount.may21 + pro5F3ClaimCount.may21
]
export const pro5WithMay21PerVisit = [
    pro5F1PerVisit.may21,
    pro5F2PerVisit.may21,
    pro5F3PerVisit.may21,
    provider5PerVisist[4]
]
// jun 21
export const pro5WithJun21Charges = [
    pro5F1Charge.jun21,
    pro5F2Charge.jun21,
    pro5F3Charge.jun21,
    pro5F1Charge.jun21 + pro5F2Charge.jun21 + pro5F3Charge.jun21
]
export const pro5WithJun21Pay = [
    pro5F1Payment.jun21,
    pro5F2Payment.jun21,
    pro5F3Payment.jun21,
    pro5F1Payment.jun21 + pro5F2Payment.jun21 + pro5F3Payment.jun21
]
export const pro5WithJun21Count = [
    pro5F1Collectable.jun21,
    pro5F2Collectable.jun21,
    pro5F3Collectable.jun21,
    pro5F1Collectable.jun21 + pro5F2Collectable.jun21 + pro5F3Collectable.jun21
]
export const pro5WithJun21NonCount = [
    pro5F1NonCollectable.jun21,
    pro5F2NonCollectable.jun21,
    pro5F3NonCollectable.jun21,
    pro5F1NonCollectable.jun21 + pro5F2NonCollectable.jun21 + pro5F3NonCollectable.jun21
]
export const pro5WithJun21Claim = [
    pro5F1ClaimCount.jun21,
    pro5F2ClaimCount.jun21,
    pro5F3ClaimCount.jun21,
    pro5F1ClaimCount.jun21 + pro5F2ClaimCount.jun21 + pro5F3ClaimCount.jun21
]
export const pro5WithJun21PerVisit = [
    pro5F1PerVisit.jun21,
    pro5F2PerVisit.jun21,
    pro5F3PerVisit.jun21,
    provider5PerVisist[5]
]
// jul 21
export const pro5WithJul21Charges = [
    pro5F1Charge.jul21,
    pro5F2Charge.jul21,
    pro5F3Charge.jul21,
    pro5F1Charge.jul21 + pro5F2Charge.jul21 + pro5F3Charge.jul21,

]
export const pro5WithJul21Pay = [
    pro5F1Payment.jul21,
    pro5F2Payment.jul21,
    pro5F3Payment.jul21,
    pro5F1Payment.jul21 + pro5F2Payment.jul21 + pro5F3Payment.jul21
]
export const pro5WithJul21Count = [
    pro5F1Collectable.jul21,
    pro5F2Collectable.jul21,
    pro5F3Collectable.jul21,
    pro5F1Collectable.jul21 + pro5F2Collectable.jul21 + pro5F3Collectable.jul21
]
export const pro5WithJul21NonCount = [
    pro5F1NonCollectable.jul21,
    pro5F2NonCollectable.jul21,
    pro5F3NonCollectable.jul21,
    pro5F1NonCollectable.jul21 + pro5F2NonCollectable.jul21 + pro5F3NonCollectable.jul21
]
export const pro5WithJul21Claim = [
    pro5F1ClaimCount.jul21,
    pro5F2ClaimCount.jul21,
    pro5F3ClaimCount.jul21,
    pro5F1ClaimCount.jul21 + pro5F2ClaimCount.jul21 + pro5F3ClaimCount.jul21
]
export const pro5WithJul21PerVisit = [
    pro5F1PerVisit.jul21,
    pro5F2PerVisit.jul21,
    pro5F3PerVisit.jul21,
    provider5PerVisist[6]
]
// aug 21
export const pro5WithAug21Charges = [
    pro5F1Charge.aug21,
    pro5F2Charge.aug21,
    pro5F3Charge.aug21,
    pro5F1Charge.aug21 + pro5F2Charge.aug21 + pro5F3Charge.aug21
]
export const pro5WithAug21Pay = [
    pro5F1Payment.aug21,
    pro5F2Payment.aug21,
    pro5F3Payment.aug21,
    pro5F1Payment.aug21 + pro5F2Payment.aug21 + pro5F3Payment.aug21
]
export const pro5WithAug21Count = [
    pro5F1Collectable.aug21,
    pro5F2Collectable.aug21,
    pro5F3Collectable.aug21,
    pro5F1Collectable.aug21 + pro5F2Collectable.aug21 + pro5F3Collectable.aug21
]
export const pro5WithAug21NonCount = [
    pro5F1NonCollectable.aug21,
    pro5F2NonCollectable.aug21,
    pro5F3NonCollectable.aug21,
    pro5F1NonCollectable.aug21 + pro5F2NonCollectable.aug21 + pro5F3NonCollectable.aug21
]
export const pro5WithAug21Claim = [
    pro5F1ClaimCount.aug21,
    pro5F2ClaimCount.aug21,
    pro5F3ClaimCount.aug21,
    pro5F1ClaimCount.aug21 + pro5F2ClaimCount.aug21 + pro5F3ClaimCount.aug21
]
export const pro5WithAug21PerVisit = [
    pro5F1PerVisit.aug21,
    pro5F2PerVisit.aug21,
    pro5F3PerVisit.aug21,
    provider5PerVisist[7]
]
// sep 21
export const pro5WithSep21Charges = [
    pro5F1Charge.sep21,
    pro5F2Charge.sep21,
    pro5F3Charge.sep21,
    pro5F1Charge.sep21 + pro5F2Charge.sep21 + pro5F3Charge.sep21
]
export const pro5WithSep21Pay = [
    pro5F1Payment.sep21,
    pro5F2Payment.sep21,
    pro5F3Payment.sep21,
    pro5F1Payment.sep21 + pro5F2Payment.sep21 + pro5F3Payment.sep21
]
export const pro5WithSep21Count = [
    pro5F1Collectable.sep21,
    pro5F2Collectable.sep21,
    pro5F3Collectable.sep21,
    pro5F1Collectable.sep21 + pro5F2Collectable.sep21 + pro5F3Collectable.sep21
]
export const pro5WithSep21NonCount = [
    pro5F1NonCollectable.sep21,
    pro5F2NonCollectable.sep21,
    pro5F3NonCollectable.sep21,
    pro5F1NonCollectable.sep21 + pro5F2NonCollectable.sep21 + pro5F3NonCollectable.sep21
]
export const pro5WithSep21Claim = [
    pro5F1ClaimCount.sep21,
    pro5F2ClaimCount.sep21,
    pro5F3ClaimCount.sep21,
    pro5F1ClaimCount.sep21 + pro5F2ClaimCount.sep21 + pro5F3ClaimCount.sep21
]
export const pro5WithSep21PerVisit = [
    pro5F1PerVisit.sep21,
    pro5F2PerVisit.sep21,
    pro5F3PerVisit.sep21,
    provider5PerVisist[8]
]
// oct 21
export const pro5WithOct21Charges = [
    pro5F1Charge.oct21,
    pro5F2Charge.oct21,
    pro5F3Charge.oct21,
    pro5F1Charge.oct21 + pro5F2Charge.oct21 + pro5F3Charge.oct21
]
export const pro5WithOct21Pay = [
    pro5F1Payment.oct21,
    pro5F2Payment.oct21,
    pro5F3Payment.oct21,
    pro5F1Payment.oct21 + pro5F2Payment.oct21 + pro5F3Payment.oct21
]
export const pro5WithOct21Count = [
    pro5F1Collectable.oct21,
    pro5F2Collectable.oct21,
    pro5F3Collectable.oct21,
    pro5F1Collectable.oct21 + pro5F2Collectable.oct21 + pro5F3Collectable.oct21
]
export const pro5WithOct21NonCount = [
    pro5F1NonCollectable.oct21,
    pro5F2NonCollectable.oct21,
    pro5F3NonCollectable.oct21,
    pro5F1NonCollectable.oct21 + pro5F2NonCollectable.oct21 + pro5F3NonCollectable.oct21
]
export const pro5WithOct21Claim = [
    pro5F1ClaimCount.oct21,
    pro5F2ClaimCount.oct21,
    pro5F3ClaimCount.oct21,
    pro5F1ClaimCount.oct21 + pro5F2ClaimCount.oct21 + pro5F3ClaimCount.oct21
]
export const pro5WithOct21PerVisit = [
    pro5F1PerVisit.oct21,
    pro5F2PerVisit.oct21,
    pro5F3PerVisit.oct21,
    provider5PerVisist[9]
]
// nov 21
export const pro5WithNov21Charges = [
    pro5F1Charge.nov21,
    pro5F2Charge.nov21,
    pro5F3Charge.nov21,
    pro5F1Charge.nov21 + pro5F2Charge.nov21 + pro5F3Charge.nov21
]
export const pro5WithNov21Pay = [
    pro5F1Payment.nov21,
    pro5F2Payment.nov21,
    pro5F3Payment.nov21,
    pro5F1Payment.nov21 + pro5F2Payment.nov21 + pro5F3Payment.nov21
]
export const pro5WithNov21Count = [
    pro5F1Collectable.nov21,
    pro5F2Collectable.nov21,
    pro5F3Collectable.nov21,
    pro5F1Collectable.nov21 + pro5F2Collectable.nov21 + pro5F3Collectable.nov21
]
export const pro5WithNov21NonCount = [
    pro5F1NonCollectable.nov21,
    pro5F2NonCollectable.nov21,
    pro5F3NonCollectable.nov21,
    pro5F1NonCollectable.nov21 + pro5F2NonCollectable.nov21 + pro5F3NonCollectable.nov21
]
export const pro5WithNov21Claim = [
    pro5F1ClaimCount.nov21,
    pro5F2ClaimCount.nov21,
    pro5F3ClaimCount.nov21,
    pro5F1ClaimCount.nov21 + pro5F2ClaimCount.nov21 + pro5F3ClaimCount.nov21
]
export const pro5WithNov21PerVisit = [
    pro5F1PerVisit.nov21,
    pro5F2PerVisit.nov21,
    pro5F3PerVisit.nov21,
    provider5PerVisist[10]
]
// dec 21
export const pro5WithDec21Charges = [
    pro5F1Charge.dec21,
    pro5F2Charge.dec21,
    pro5F3Charge.dec21,
    pro5F1Charge.dec21 + pro5F2Charge.dec21 + pro5F3Charge.dec21
]
export const pro5WithDec21Pay = [
    pro5F1Payment.dec21,
    pro5F2Payment.dec21,
    pro5F3Payment.dec21,
    pro5F1Payment.dec21 + pro5F2Payment.dec21 + pro5F3Payment.dec21
]
export const pro5WithDec21Count = [
    pro5F1Collectable.dec21,
    pro5F2Collectable.dec21,
    pro5F3Collectable.dec21,
    pro5F1Collectable.dec21 + pro5F2Collectable.dec21 + pro5F3Collectable.dec21
]
export const pro5WithDec21NonCount = [
    pro5F1NonCollectable.dec21,
    pro5F2NonCollectable.dec21,
    pro5F3NonCollectable.dec21,
    pro5F1NonCollectable.dec21 + pro5F2NonCollectable.dec21 + pro5F3NonCollectable.dec21
] 
export const pro5WithDec21Claim = [
    pro5F1ClaimCount.dec21,
    pro5F2ClaimCount.dec21,
    pro5F3ClaimCount.dec21,
    pro5F1ClaimCount.dec21 + pro5F2ClaimCount.dec21 + pro5F3ClaimCount.dec21
]
export const pro5WithDec21PerVisit = [
    pro5F1PerVisit.dec21,
    pro5F2PerVisit.dec21,
    pro5F3PerVisit.dec21,
    provider5PerVisist[11]
]

// provider-1 
// jan 22
export const pro5WithJan22Charges = [
    pro5F1Charge.jan22,
    pro5F2Charge.jan22,
    pro5F3Charge.jan22,
    pro5F1Charge.jan22 + pro5F2Charge.jan22 + pro5F3Charge.jan22
]
export const pro5WithJan22Pay = [
    pro5F1Payment.jan22,
    pro5F2Payment.jan22,
    pro5F3Payment.jan22,
    pro5F1Payment.jan22 + pro5F2Payment.jan22 + pro5F3Payment.jan22
]
export const pro5WithJan22Count = [
    pro5F1Collectable.jan22,
    pro5F2Collectable.jan22,
    pro5F3Collectable.jan22,
    pro5F1Collectable.jan22 + pro5F2Collectable.jan22 + pro5F3Collectable.jan22
]
export const pro5WithJan22NonCount = [
    pro5F1NonCollectable.jan22,
    pro5F2NonCollectable.jan22,
    pro5F3NonCollectable.jan22,
    pro5F1NonCollectable.jan22 + pro5F2NonCollectable.jan22 + pro5F3NonCollectable.jan22
]
export const pro5WithJan22Claim = [
    pro5F1ClaimCount.jan22,
    pro5F2ClaimCount.jan22,
    pro5F3ClaimCount.jan22,
    pro5F1ClaimCount.jan22 + pro5F2ClaimCount.jan22 + pro5F3ClaimCount.jan22
]
export const pro5WithJan22PerVisit = [
    pro5F1PerVisit.jan22,
    pro5F2PerVisit.jan22,
    pro5F3PerVisit.jan22,
    provider5PerVisist[12]
]
// feb 22
export const pro5WithFeb22Charges = [
    pro5F1Charge.feb22,
    pro5F2Charge.feb22,
    pro5F3Charge.feb22,
    pro5F1Charge.feb22 + pro5F2Charge.feb22 + pro5F3Charge.feb22
]
export const pro5WithFeb22Pay = [
    pro5F1Payment.feb22,
    pro5F2Payment.feb22,
    pro5F3Payment.feb22,
    pro5F1Payment.feb22 + pro5F2Payment.feb22 + pro5F3Payment.feb22
]
export const pro5WithFeb22Count = [
    pro5F1Collectable.feb22,
    pro5F2Collectable.feb22,
    pro5F3Collectable.feb22,
    pro5F1Collectable.feb22 + pro5F2Collectable.feb22 + pro5F3Collectable.feb22
]
export const pro5WithFeb22NonCount = [
    pro5F1NonCollectable.feb22,
    pro5F2NonCollectable.feb22,
    pro5F3NonCollectable.feb22,
    pro5F1NonCollectable.feb22 + pro5F2NonCollectable.feb22 + pro5F3NonCollectable.feb22
]
export const pro5WithFeb22Claim = [
    pro5F1ClaimCount.feb22,
    pro5F2ClaimCount.feb22,
    pro5F3ClaimCount.feb22,
    pro5F1ClaimCount.feb22 + pro5F2ClaimCount.feb22 + pro5F3ClaimCount.feb22
]
export const pro5WithFeb22PerVisit = [
    pro5F1PerVisit.feb22,
    pro5F2PerVisit.feb22,
    pro5F3PerVisit.feb22,
    provider5PerVisist[13]
]
// mar 22
export const pro5WithMar22Charges = [
    pro5F1Charge.mar22,
    pro5F2Charge.mar22,
    pro5F3Charge.mar22,
    pro5F1Charge.mar22 + pro5F2Charge.mar22 + pro5F3Charge.mar22
]
export const pro5WithMar22Pay = [
    pro5F1Payment.mar22,
    pro5F2Payment.mar22,
    pro5F3Payment.mar22,
    pro5F1Payment.mar22 + pro5F2Payment.mar22 + pro5F3Payment.mar22
]
export const pro5WithMar22Count = [
    pro5F1Collectable.mar22,
    pro5F2Collectable.mar22,
    pro5F3Collectable.mar22,
    pro5F1Collectable.mar22 + pro5F2Collectable.mar22 + pro5F3Collectable.mar22
]
export const pro5WithMar22NonCount = [
    pro5F1NonCollectable.mar22,
    pro5F2NonCollectable.mar22,
    pro5F3NonCollectable.mar22,
    pro5F1NonCollectable.mar22 + pro5F2NonCollectable.mar22 + pro5F3NonCollectable.mar22
]
export const pro5WithMar22Claim = [
    pro5F1ClaimCount.mar22,
    pro5F2ClaimCount.mar22,
    pro5F3ClaimCount.mar22,
    pro5F1ClaimCount.mar22 + pro5F2ClaimCount.mar22 + pro5F3ClaimCount.mar22
]
export const pro5WithMar22PerVisit = [
    pro5F1PerVisit.mar22,
    pro5F2PerVisit.mar22,
    pro5F3PerVisit.mar22,
    provider5PerVisist[14]
]
// april 22
export const pro5WithApr22Charges = [
    pro5F1Charge.apr22,
    pro5F2Charge.apr22,
    pro5F3Charge.apr22,
    pro5F1Charge.apr22 + pro5F2Charge.apr22 + pro5F3Charge.apr22
]
export const pro5WithApr22Pay = [
    pro5F1Payment.apr22,
    pro5F2Payment.apr22,
    pro5F3Payment.apr22,
    pro5F1Payment.apr22 + pro5F2Payment.apr22 + pro5F3Payment.apr22
]
export const pro5WithApr22Count = [
    pro5F1Collectable.apr22,
    pro5F2Collectable.apr22,
    pro5F3Collectable.apr22,
    pro5F1Collectable.apr22 + pro5F2Collectable.apr22 + pro5F3Collectable.apr22
]
export const pro5WithApr22NonCount = [
    pro5F1NonCollectable.apr22,
    pro5F2NonCollectable.apr22,
    pro5F3NonCollectable.apr22,
    pro5F1NonCollectable.apr22 + pro5F2NonCollectable.apr22 + pro5F3NonCollectable.apr22
]
export const pro5WithApr22Claim = [
    pro5F1ClaimCount.apr22,
    pro5F2ClaimCount.apr22,
    pro5F3ClaimCount.apr22,
    pro5F1ClaimCount.apr22 + pro5F2ClaimCount.apr22 + pro5F3ClaimCount.apr22
]
export const pro5WithApr22PerVisit = [
    pro5F1PerVisit.apr22,
    pro5F2PerVisit.apr22,
    pro5F3PerVisit.apr22,
    provider5PerVisist[15]
]
// may 22
export const pro5WithMay22Charges = [
    pro5F1Charge.may22,
    pro5F2Charge.may22,
    pro5F3Charge.may22,
    pro5F1Charge.may22 + pro5F2Charge.may22 + pro5F3Charge.may22
]
export const pro5WithMay22Pay = [
    pro5F1Payment.may22,
    pro5F2Payment.may22,
    pro5F3Payment.may22,
    pro5F1Payment.may22 + pro5F2Payment.may22 + pro5F3Payment.may22
]
export const pro5WithMay22Count = [
    pro5F1Collectable.may22,
    pro5F2Collectable.may22,
    pro5F3Collectable.may22,
    pro5F1Collectable.may22 + pro5F2Collectable.may22 + pro5F3Collectable.may22
]
export const pro5WithMay22NonCount = [
    pro5F1NonCollectable.may22,
    pro5F2NonCollectable.may22,
    pro5F3NonCollectable.may22,
    pro5F1NonCollectable.may22 + pro5F2NonCollectable.may22 + pro5F3NonCollectable.may22
]
export const pro5WithMay22Claim = [
    pro5F1ClaimCount.may22,
    pro5F2ClaimCount.may22,
    pro5F3ClaimCount.may22,
    pro5F1ClaimCount.may22 + pro5F2ClaimCount.may22 + pro5F3ClaimCount.may22
]
export const pro5WithMay22PerVisit = [
    pro5F1PerVisit.may22,
    pro5F2PerVisit.may22,
    pro5F3PerVisit.may22,
    provider5PerVisist[16]
]
// jun 22
export const pro5WithJun22Charges = [
    pro5F1Charge.jun22,
    pro5F2Charge.jun22,
    pro5F3Charge.jun22,
    pro5F1Charge.jun22 + pro5F2Charge.jun22 + pro5F3Charge.jun22
]
export const pro5WithJun22Pay = [
    pro5F1Payment.jun22,
    pro5F2Payment.jun22,
    pro5F3Payment.jun22,
    pro5F1Payment.jun22 + pro5F2Payment.jun22 + pro5F3Payment.jun22
]
export const pro5WithJun22Count = [
    pro5F1Collectable.jun22,
    pro5F2Collectable.jun22,
    pro5F3Collectable.jun22,
    pro5F1Collectable.jun22 + pro5F2Collectable.jun22 + pro5F3Collectable.jun22
]
export const pro5WithJun22NonCount = [
    pro5F1NonCollectable.jun22,
    pro5F2NonCollectable.jun22,
    pro5F3NonCollectable.jun22,
    pro5F1NonCollectable.jun22 + pro5F2NonCollectable.jun22 + pro5F3NonCollectable.jun22
]
export const pro5WithJun22Claim = [
    pro5F1ClaimCount.jun22,
    pro5F2ClaimCount.jun22,
    pro5F3ClaimCount.jun22,
    pro5F1ClaimCount.jun22 + pro5F2ClaimCount.jun22 + pro5F3ClaimCount.jun22
]
export const pro5WithJun22PerVisit = [
    pro5F1PerVisit.jun22,
    pro5F2PerVisit.jun22,
    pro5F3PerVisit.jun22,
    provider5PerVisist[17]
]
// jul 22
export const pro5WithJul22Charges = [
    pro5F1Charge.jul22,
    pro5F2Charge.jul22,
    pro5F3Charge.jul22,
    pro5F1Charge.jul22 + pro5F2Charge.jul22 + pro5F3Charge.jul22
]
export const pro5WithJul22Pay = [
    pro5F1Payment.jul22,
    pro5F2Payment.jul22,
    pro5F3Payment.jul22,
    pro5F1Payment.jul22 + pro5F2Payment.jul22 + pro5F3Payment.jul22
]
export const pro5WithJul22Count = [
    pro5F1Collectable.jul22,
    pro5F2Collectable.jul22,
    pro5F3Collectable.jul22,
    pro5F1Collectable.jul22 + pro5F2Collectable.jul22 + pro5F3Collectable.jul22
]
export const pro5WithJul22NonCount = [
    pro5F1NonCollectable.jul22,
    pro5F2NonCollectable.jul22,
    pro5F3NonCollectable.jul22,
    pro5F1NonCollectable.jul22 + pro5F2NonCollectable.jul22 + pro5F3NonCollectable.jul22
]
export const pro5WithJul22Claim = [
    pro5F1ClaimCount.jul22,
    pro5F2ClaimCount.jul22,
    pro5F3ClaimCount.jul22,
    pro5F1ClaimCount.jul22 + pro5F2ClaimCount.jul22 + pro5F3ClaimCount.jul22
]
export const pro5WithJul22PerVisit = [
    pro5F1PerVisit.jul22,
    pro5F2PerVisit.jul22,
    pro5F3PerVisit.jul22,
    provider5PerVisist[18]
]
// aug 22
export const pro5WithAug22Charges = [
    pro5F1Charge.aug22,
    pro5F2Charge.aug22,
    pro5F3Charge.aug22,
    pro5F1Charge.aug22 + pro5F2Charge.aug22 + pro5F3Charge.aug22
]
export const pro5WithAug22Pay = [
    pro5F1Payment.aug22,
    pro5F2Payment.aug22,
    pro5F3Payment.aug22,
    pro5F1Payment.aug22 + pro5F2Payment.aug22 + pro5F3Payment.aug22
]
export const pro5WithAug22Count = [
    pro5F1Collectable.aug22,
    pro5F2Collectable.aug22,
    pro5F3Collectable.aug22,
    pro5F1Collectable.aug22 + pro5F2Collectable.aug22 + pro5F3Collectable.aug22
]
export const pro5WithAug22NonCount = [
    pro5F1NonCollectable.aug22,
    pro5F2NonCollectable.aug22,
    pro5F3NonCollectable.aug22,
    pro5F1NonCollectable.aug22 + pro5F2NonCollectable.aug22 + pro5F3NonCollectable.aug22
]
export const pro5WithAug22Claim = [
    pro5F1ClaimCount.aug22,
    pro5F2ClaimCount.aug22,
    pro5F3ClaimCount.aug22,
    pro5F1ClaimCount.aug22 + pro5F2ClaimCount.aug22 + pro5F3ClaimCount.aug22
]
export const pro5WithAug22PerVisit = [
    pro5F1PerVisit.aug22,
    pro5F2PerVisit.aug22,
    pro5F3PerVisit.aug22,
    provider5PerVisist[19]
]
// sep 22
export const pro5WithSep22Charges = [
    pro5F1Charge.sep22,
    pro5F2Charge.sep22,
    pro5F3Charge.sep22,
    pro5F1Charge.sep22 + pro5F2Charge.sep22 + pro5F3Charge.sep22
]
export const pro5WithSep22Pay = [
    pro5F1Payment.sep22,
    pro5F2Payment.sep22,
    pro5F3Payment.sep22,
    pro5F1Payment.sep22 + pro5F2Payment.sep22 + pro5F3Payment.sep22
]
export const pro5WithSep22Count = [
    pro5F1Collectable.sep22,
    pro5F2Collectable.sep22,
    pro5F3Collectable.sep22,
    pro5F1Collectable.sep22 + pro5F2Collectable.sep22 + pro5F3Collectable.sep22
]
export const pro5WithSep22NonCount = [
    pro5F1NonCollectable.sep22,
    pro5F2NonCollectable.sep22,
    pro5F3NonCollectable.sep22,
    pro5F1NonCollectable.sep22 + pro5F2NonCollectable.sep22 + pro5F3NonCollectable.sep22
]
export const pro5WithSep22Claim = [
    pro5F1ClaimCount.sep22,
    pro5F2ClaimCount.sep22,
    pro5F3ClaimCount.sep22,
    pro5F1ClaimCount.sep22 + pro5F2ClaimCount.sep22 + pro5F3ClaimCount.sep22
]
export const pro5WithSep22PerVisit = [
    pro5F1PerVisit.sep22,
    pro5F2PerVisit.sep22,
    pro5F3PerVisit.sep22,
    provider5PerVisist[20]
]
// oct 22
export const pro5WithOct22Charges = [
    pro5F1Charge.oct22,
    pro5F2Charge.oct22,
    pro5F3Charge.oct22,
    pro5F1Charge.oct22 + pro5F2Charge.oct22 + pro5F3Charge.oct22
]
export const pro5WithOct22Pay = [
    pro5F1Payment.oct22,
    pro5F2Payment.oct22,
    pro5F3Payment.oct22,
    pro5F1Payment.oct22 + pro5F2Payment.oct22 + pro5F3Payment.oct22
]
export const pro5WithOct22Count = [
    pro5F1Collectable.oct22,
    pro5F2Collectable.oct22,
    pro5F3Collectable.oct22,
    pro5F1Collectable.oct22 + pro5F2Collectable.oct22 + pro5F3Collectable.oct22
]
export const pro5WithOct22NonCount = [
    pro5F1NonCollectable.oct22,
    pro5F2NonCollectable.oct22,
    pro5F3NonCollectable.oct22,
    pro5F1NonCollectable.oct22 + pro5F2NonCollectable.oct22 + pro5F3NonCollectable.oct22
]
export const pro5WithOct22Claim = [
    pro5F1ClaimCount.oct22,
    pro5F2ClaimCount.oct22,
    pro5F3ClaimCount.oct22,
    pro5F1ClaimCount.oct22 + pro5F2ClaimCount.oct22 + pro5F3ClaimCount.oct22
]
export const pro5WithOct22PerVisit = [
    pro5F1PerVisit.oct22,
    pro5F2PerVisit.oct22,
    pro5F3PerVisit.oct22,
    provider5PerVisist[21]
]
// nov 22
export const pro5WithNov22Charges = [
    pro5F1Charge.nov22,
    pro5F2Charge.nov22,
    pro5F3Charge.nov22,
    pro5F1Charge.nov22 + pro5F2Charge.nov22 + pro5F3Charge.nov22
]
export const pro5WithNov22Pay = [
    pro5F1Payment.nov22,
    pro5F2Payment.nov22,
    pro5F3Payment.nov22,
    pro5F1Payment.nov22 + pro5F2Payment.nov22 + pro5F3Payment.nov22
]
export const pro5WithNov22Count = [
    pro5F1Collectable.nov22,
    pro5F2Collectable.nov22,
    pro5F3Collectable.nov22,
    pro5F1Collectable.nov22 + pro5F2Collectable.nov22 + pro5F3Collectable.nov22
]
export const pro5WithNov22NonCount = [
    pro5F1NonCollectable.nov22,
    pro5F2NonCollectable.nov22,
    pro5F3NonCollectable.nov22,
    pro5F1NonCollectable.nov22 + pro5F2NonCollectable.nov22 + pro5F3NonCollectable.nov22
]
export const pro5WithNov22Claim = [
    pro5F1ClaimCount.nov22,
    pro5F2ClaimCount.nov22,
    pro5F3ClaimCount.nov22,
    pro5F1ClaimCount.nov22 + pro5F2ClaimCount.nov22 + pro5F3ClaimCount.nov22
]
export const pro5WithNov22PerVisit = [
    pro5F1PerVisit.nov22,
    pro5F2PerVisit.nov22,
    pro5F3PerVisit.nov22,
    provider5PerVisist[22]
]
// dec 22
export const pro5WithDec22Charges = [
    pro5F1Charge.dec22,
    pro5F2Charge.dec22,
    pro5F3Charge.dec22,
    pro5F1Charge.dec22 + pro5F2Charge.dec22 + pro5F3Charge.dec22
]
export const pro5WithDec22Pay = [
    pro5F1Payment.dec22,
    pro5F2Payment.dec22,
    pro5F3Payment.dec22,
    pro5F1Payment.dec22 + pro5F2Payment.dec22 + pro5F3Payment.dec22
]
export const pro5WithDec22Count = [
    pro5F1Collectable.dec22,
    pro5F2Collectable.dec22,
    pro5F3Collectable.dec22,
    pro5F1Collectable.dec22 + pro5F2Collectable.dec22 + pro5F3Collectable.dec22
]
export const pro5WithDec22NonCount = [
    pro5F1NonCollectable.dec22,
    pro5F2NonCollectable.dec22,
    pro5F3NonCollectable.dec22,
    pro5F1NonCollectable.dec22 + pro5F2NonCollectable.dec22 + pro5F3NonCollectable.dec22
]
export const pro5WithDec22Claim = [
    pro5F1ClaimCount.dec22,
    pro5F2ClaimCount.dec22,
    pro5F3ClaimCount.dec22,
    pro5F1ClaimCount.dec22 + pro5F2ClaimCount.dec22 + pro5F3ClaimCount.dec22
]
export const pro5WithDec22PerVisit = [
    pro5F1PerVisit.dec22,
    pro5F2PerVisit.dec22,
    pro5F3PerVisit.dec22,
    provider5PerVisist[23]
]

// provider-1 
// jan 23
export const pro5WithJan23Charges = [
    pro5F1Charge.jan23,
    pro5F2Charge.jan23,
    pro5F3Charge.jan23,
    pro5F1Charge.jan23 + pro5F2Charge.jan23 + pro5F3Charge.jan23
]
export const pro5WithJan23Pay = [
    pro5F1Payment.jan23,
    pro5F2Payment.jan23,
    pro5F3Payment.jan23,
    pro5F1Payment.jan23 + pro5F2Payment.jan23 + pro5F3Payment.jan23
]
export const pro5WithJan23Count = [
    pro5F1Collectable.jan23,
    pro5F2Collectable.jan23,
    pro5F3Collectable.jan23,
    pro5F1Collectable.jan23 + pro5F2Collectable.jan23 + pro5F3Collectable.jan23
]
export const pro5WithJan23NonCount = [
    pro5F1NonCollectable.jan23,
    pro5F2NonCollectable.jan23,
    pro5F3NonCollectable.jan23,
    pro5F1NonCollectable.jan23 + pro5F2NonCollectable.jan23 + pro5F3NonCollectable.jan23
]
export const pro5WithJan23Claim = [
    pro5F1ClaimCount.jan23,
    pro5F2ClaimCount.jan23,
    pro5F3ClaimCount.jan23,
    pro5F1ClaimCount.jan23 + pro5F2ClaimCount.jan23 + pro5F3ClaimCount.jan23
]
export const pro5WithJan23PerVisit = [
    pro5F1PerVisit.jan23,
    pro5F2PerVisit.jan23,
    pro5F3PerVisit.jan23,
    provider5PerVisist[24]
]
// feb 23
export const pro5WithFeb23Charges = [
    pro5F1Charge.feb23,
    pro5F2Charge.feb23,
    pro5F3Charge.feb23,
    pro5F1Charge.feb23 + pro5F2Charge.feb23 + pro5F3Charge.feb23
]
export const pro5WithFeb23Pay = [
    pro5F1Payment.feb23,
    pro5F2Payment.feb23,
    pro5F3Payment.feb23,
    pro5F1Payment.feb23 + pro5F2Payment.feb23 + pro5F3Payment.feb23
]
export const pro5WithFeb23Count = [
    pro5F1Collectable.feb23,
    pro5F2Collectable.feb23,
    pro5F3Collectable.feb23,
    pro5F1Collectable.feb23 + pro5F2Collectable.feb23 + pro5F3Collectable.feb23
]
export const pro5WithFeb23NonCount = [
    pro5F1NonCollectable.feb23,
    pro5F2NonCollectable.feb23,
    pro5F3NonCollectable.feb23,
    pro5F1NonCollectable.feb23 + pro5F2NonCollectable.feb23 + pro5F3NonCollectable.feb23
]
export const pro5WithFeb23Claim = [
    pro5F1ClaimCount.feb23,
    pro5F2ClaimCount.feb23,
    pro5F3ClaimCount.feb23,
    pro5F1ClaimCount.feb23 + pro5F2ClaimCount.feb23 + pro5F3ClaimCount.feb23
]
export const pro5WithFeb23PerVisit = [
    pro5F1PerVisit.feb23,
    pro5F2PerVisit.feb23,
    pro5F3PerVisit.feb23,
    provider5PerVisist[25]
]
// mar 23
export const pro5WithMar23Charges = [
    pro5F1Charge.mar23,
    pro5F2Charge.mar23,
    pro5F3Charge.mar23,
    pro5F1Charge.mar23 + pro5F2Charge.mar23 + pro5F3Charge.mar23
]
export const pro5WithMar23Pay = [
    pro5F1Payment.mar23,
    pro5F2Payment.mar23,
    pro5F3Payment.mar23,
    pro5F1Payment.mar23 + pro5F2Payment.mar23 + pro5F3Payment.mar23
]
export const pro5WithMar23Count = [
    pro5F1Collectable.mar23,
    pro5F2Collectable.mar23,
    pro5F3Collectable.mar23,
    pro5F1Collectable.mar23 + pro5F2Collectable.mar23 + pro5F3Collectable.mar23
]
export const pro5WithMar23NonCount = [
    pro5F1NonCollectable.mar23,
    pro5F2NonCollectable.mar23,
    pro5F3NonCollectable.mar23,
    pro5F1NonCollectable.mar23 + pro5F2NonCollectable.mar23 + pro5F3NonCollectable.mar23
]
export const pro5WithMar23Claim = [
    pro5F1ClaimCount.mar23,
    pro5F2ClaimCount.mar23,
    pro5F3ClaimCount.mar23,
    pro5F1ClaimCount.mar23 + pro5F2ClaimCount.mar23 + pro5F3ClaimCount.mar23
]
export const pro5WithMar23PerVisit = [
    pro5F1PerVisit.mar23,
    pro5F2PerVisit.mar23,
    pro5F3PerVisit.mar23,
    provider5PerVisist[26]
]
// april 23
export const pro5WithApr23Charges = [
    pro5F1Charge.apr23,
    pro5F2Charge.apr23,
    pro5F3Charge.apr23,
    pro5F1Charge.apr23 + pro5F2Charge.apr23 + pro5F3Charge.apr23
]
export const pro5WithApr23Pay = [
    pro5F1Payment.apr23,
    pro5F2Payment.apr23,
    pro5F3Payment.apr23,
    pro5F1Payment.apr23 + pro5F2Payment.apr23 + pro5F3Payment.apr23
]
export const pro5WithApr23Count = [
    pro5F1Collectable.apr23,
    pro5F2Collectable.apr23,
    pro5F3Collectable.apr23,
    pro5F1Collectable.apr23 + pro5F2Collectable.apr23 + pro5F3Collectable.apr23
]
export const pro5WithApr23NonCount = [
    pro5F1NonCollectable.apr23,
    pro5F2NonCollectable.apr23,
    pro5F3NonCollectable.apr23,
    pro5F1NonCollectable.apr23 + pro5F2NonCollectable.apr23 + pro5F3NonCollectable.apr23
]
export const pro5WithApr23Claim = [
    pro5F1ClaimCount.apr23,
    pro5F2ClaimCount.apr23,
    pro5F3ClaimCount.apr23,
    pro5F1ClaimCount.apr23 + pro5F2ClaimCount.apr23 + pro5F3ClaimCount.apr23
]
export const pro5WithApr23PerVisit = [
    pro5F1PerVisit.apr23,
    pro5F2PerVisit.apr23,
    pro5F3PerVisit.apr23,
    provider5PerVisist[27]
]
// may 23
export const pro5WithMay23Charges = [
    pro5F1Charge.may23,
    pro5F2Charge.may23,
    pro5F3Charge.may23,
    pro5F1Charge.may23 + pro5F2Charge.may23 + pro5F3Charge.may23
]
export const pro5WithMay23Pay = [
    pro5F1Payment.may23,
    pro5F2Payment.may23,
    pro5F3Payment.may23,
    pro5F1Payment.may23 + pro5F2Payment.may23 + pro5F3Payment.may23
]
export const pro5WithMay23Count = [
    pro5F1Collectable.may23,
    pro5F2Collectable.may23,
    pro5F3Collectable.may23,
    pro5F1Collectable.may23 + pro5F2Collectable.may23 + pro5F3Collectable.may23
]
export const pro5WithMay23NonCount = [
    pro5F1NonCollectable.may23,
    pro5F2NonCollectable.may23,
    pro5F3NonCollectable.may23,
    pro5F1NonCollectable.may23 + pro5F2NonCollectable.may23 + pro5F3NonCollectable.may23
]
export const pro5WithMay23Claim = [
    pro5F1ClaimCount.may23,
    pro5F2ClaimCount.may23,
    pro5F3ClaimCount.may23,
    pro5F1ClaimCount.may23 + pro5F2ClaimCount.may23 + pro5F3ClaimCount.may23
]
export const pro5WithMay23PerVisit = [
    pro5F1PerVisit.may23,
    pro5F2PerVisit.may23,
    pro5F3PerVisit.may23,
    provider5PerVisist[28]
]
// jun 23
export const pro5WithJun23Charges = [
    pro5F1Charge.jun23,
    pro5F2Charge.jun23,
    pro5F3Charge.jun23,
    pro5F1Charge.jun23 + pro5F2Charge.jun23 + pro5F3Charge.jun23
]
export const pro5WithJun23Pay = [
    pro5F1Payment.jun23,
    pro5F2Payment.jun23,
    pro5F3Payment.jun23,
    pro5F1Payment.jun23 + pro5F2Payment.jun23 + pro5F3Payment.jun23
]
export const pro5WithJun23Count = [
    pro5F1Collectable.jun23,
    pro5F2Collectable.jun23,
    pro5F3Collectable.jun23,
    pro5F1Collectable.jun23 + pro5F2Collectable.jun23 + pro5F3Collectable.jun23
]
export const pro5WithJun23NonCount = [
    pro5F1NonCollectable.jun23,
    pro5F2NonCollectable.jun23,
    pro5F3NonCollectable.jun23,
    pro5F1NonCollectable.jun23 + pro5F2NonCollectable.jun23 + pro5F3NonCollectable.jun23
]
export const pro5WithJun23Claim = [
    pro5F1ClaimCount.jun23,
    pro5F2ClaimCount.jun23,
    pro5F3ClaimCount.jun23,
    pro5F1ClaimCount.jun23 + pro5F2ClaimCount.jun23 + pro5F3ClaimCount.jun23
]
export const pro5WithJun23PerVisit = [
    pro5F1PerVisit.jun23,
    pro5F2PerVisit.jun23,
    pro5F3PerVisit.jun23,
    provider5PerVisist[29]
]
// jul 23
export const pro5WithJul23Charges = [
    pro5F1Charge.jul23,
    pro5F2Charge.jul23,
    pro5F3Charge.jul23,
    pro5F1Charge.jul23 + pro5F2Charge.jul23 + pro5F3Charge.jul23
]
export const pro5WithJul23Pay = [
    pro5F1Payment.jul23,
    pro5F2Payment.jul23,
    pro5F3Payment.jul23,
    pro5F1Payment.jul23 + pro5F2Payment.jul23 + pro5F3Payment.jul23
]
export const pro5WithJul23Count = [
    pro5F1Collectable.jul23,
    pro5F2Collectable.jul23,
    pro5F3Collectable.jul23,
    pro5F1Collectable.jul23 + pro5F2Collectable.jul23 + pro5F3Collectable.jul23
]
export const pro5WithJul23NonCount = [
    pro5F1NonCollectable.jul23,
    pro5F2NonCollectable.jul23,
    pro5F3NonCollectable.jul23,
    pro5F1NonCollectable.jul23 + pro5F2NonCollectable.jul23 + pro5F3NonCollectable.jul23
]
export const pro5WithJul23Claim = [
    pro5F1ClaimCount.jul23,
    pro5F2ClaimCount.jul23,
    pro5F3ClaimCount.jul23,
    pro5F1ClaimCount.jul23 + pro5F2ClaimCount.jul23 + pro5F3ClaimCount.jul23
]
export const pro5WithJul23PerVisit = [
    pro5F1PerVisit.jul23,
    pro5F2PerVisit.jul23,
    pro5F3PerVisit.jul23,
    provider5PerVisist[30]
]
// aug 23
export const pro5WithAug23Charges = [
    pro5F1Charge.aug23,
    pro5F2Charge.aug23,
    pro5F3Charge.aug23,
    pro5F1Charge.aug23 + pro5F2Charge.aug23 + pro5F3Charge.aug23
]
export const pro5WithAug23Pay = [
    pro5F1Payment.aug23,
    pro5F2Payment.aug23,
    pro5F3Payment.aug23,
    pro5F1Payment.aug23 + pro5F2Payment.aug23 + pro5F3Payment.aug23
]
export const pro5WithAug23Count = [
    pro5F1Collectable.aug23,
    pro5F2Collectable.aug23,
    pro5F3Collectable.aug23,
    pro5F1Collectable.aug23 + pro5F2Collectable.aug23 + pro5F3Collectable.aug23
]
export const pro5WithAug23NonCount = [
    pro5F1NonCollectable.aug23,
    pro5F2NonCollectable.aug23,
    pro5F3NonCollectable.aug23,
    pro5F1NonCollectable.aug23 + pro5F2NonCollectable.aug23 + pro5F3NonCollectable.aug23
]
export const pro5WithAug23Claim = [
    pro5F1ClaimCount.aug23,
    pro5F2ClaimCount.aug23,
    pro5F3ClaimCount.aug23,
    pro5F1ClaimCount.aug23 + pro5F2ClaimCount.aug23 + pro5F3ClaimCount.aug23
]
export const pro5WithAug23PerVisit = [
    pro5F1PerVisit.aug23,
    pro5F2PerVisit.aug23,
    pro5F3PerVisit.aug23,
    provider5PerVisist[31]
]
// sep 23
export const pro5WithSep23Charges = [
    pro5F1Charge.sep23,
    pro5F2Charge.sep23,
    pro5F3Charge.sep23,
    pro5F1Charge.sep23 + pro5F2Charge.sep23 + pro5F3Charge.sep23
]
export const pro5WithSep23Pay = [
    pro5F1Payment.sep23,
    pro5F2Payment.sep23,
    pro5F3Payment.sep23,
    pro5F1Payment.sep23 + pro5F2Payment.sep23 + pro5F3Payment.sep23
]
export const pro5WithSep23Count = [
    pro5F1Collectable.sep23,
    pro5F2Collectable.sep23,
    pro5F3Collectable.sep23,
    pro5F1Collectable.sep23 + pro5F2Collectable.sep23 + pro5F3Collectable.sep23
]
export const pro5WithSep23NonCount = [
    pro5F1NonCollectable.sep23,
    pro5F2NonCollectable.sep23,
    pro5F3NonCollectable.sep23,
    pro5F1NonCollectable.sep23 + pro5F2NonCollectable.sep23 + pro5F3NonCollectable.sep23
]
export const pro5WithSep23Claim = [
    pro5F1ClaimCount.sep23,
    pro5F2ClaimCount.sep23,
    pro5F3ClaimCount.sep23,
    pro5F1ClaimCount.sep23 + pro5F2ClaimCount.sep23 + pro5F3ClaimCount.sep23
]
export const pro5WithSep23PerVisit = [
    pro5F1PerVisit.sep23,
    pro5F2PerVisit.sep23,
    pro5F3PerVisit.sep23,
    provider5PerVisist[32]
]
// oct 23
export const pro5WithOct23Charges = [
    pro5F1Charge.oct23,
    pro5F2Charge.oct23,
    pro5F3Charge.oct23,
    pro5F1Charge.oct23 + pro5F2Charge.oct23 + pro5F3Charge.oct23
]
export const pro5WithOct23Pay = [
    pro5F1Payment.oct23,
    pro5F2Payment.oct23,
    pro5F3Payment.oct23,
    pro5F1Payment.oct23 + pro5F2Payment.oct23 + pro5F3Payment.oct23
]
export const pro5WithOct23Count = [
    pro5F1Collectable.oct23,
    pro5F2Collectable.oct23,
    pro5F3Collectable.oct23,
    pro5F1Collectable.oct23 + pro5F2Collectable.oct23 + pro5F3Collectable.oct23
]
export const pro5WithOct23NonCount = [
    pro5F1NonCollectable.oct23,
    pro5F2NonCollectable.oct23,
    pro5F3NonCollectable.oct23,
    pro5F1NonCollectable.oct23 + pro5F2NonCollectable.oct23 + pro5F3NonCollectable.oct23
]
export const pro5WithOct23Claim = [
    pro5F1ClaimCount.oct23,
    pro5F2ClaimCount.oct23,
    pro5F3ClaimCount.oct23,
    pro5F1ClaimCount.oct23 + pro5F2ClaimCount.oct23 + pro5F3ClaimCount.oct23
]
export const pro5WithOct23PerVisit = [
    pro5F1PerVisit.oct23,
    pro5F2PerVisit.oct23,
    pro5F3PerVisit.oct23,
    provider5PerVisist[33]
]
// nov 23
export const pro5WithNov23Charges = [
    pro5F1Charge.nov23,
    pro5F2Charge.nov23,
    pro5F3Charge.nov23,
    pro5F1Charge.nov23 + pro5F2Charge.nov23 + pro5F3Charge.nov23
]
export const pro5WithNov23Pay = [
    pro5F1Payment.nov23,
    pro5F2Payment.nov23,
    pro5F3Payment.nov23,
    pro5F1Payment.nov23 +
    pro5F2Payment.nov23 + 
    pro5F3Payment.nov23
]
export const pro5WithNov23Count = [
    pro5F1Collectable.nov23,
    pro5F2Collectable.nov23,
    pro5F3Collectable.nov23,
    pro5F1Collectable.nov23 +
    pro5F2Collectable.nov23 +
    pro5F3Collectable.nov23
]
export const pro5WithNov23NonCount = [
    pro5F1NonCollectable.nov23,
    pro5F2NonCollectable.nov23,
    pro5F3NonCollectable.nov23,
    pro5F1NonCollectable.nov23+
    pro5F2NonCollectable.nov23+
    pro5F3NonCollectable.nov23
]
export const pro5WithNov23Claim = [
    pro5F1ClaimCount.nov23,
    pro5F2ClaimCount.nov23,
    pro5F3ClaimCount.nov23,
    pro5F1ClaimCount.nov23 + pro5F2ClaimCount.nov23 + pro5F3ClaimCount.nov23
]
export const pro5WithNov23PerVisit = [
    pro5F1PerVisit.nov23,
    pro5F2PerVisit.nov23,
    pro5F3PerVisit.nov23,
    provider5PerVisist[34]
]
// comm
    // export const pro5WithJan21Charges = [
    //     pro5F1Charge.jan21,
    //     pro5F2Charge.jan21,
    //     pro5F3Charge.jan21
    // ]
    // export const pro5WithJan21Pay = [
    //     pro5F1Payment.jan21,
    //     pro5F2Payment.jan21,
    //     pro5F3Payment.jan21
    // ]
    // export const pro5WithJan21Count = [
    //     pro5F1Collectable.jan21,
    //     pro5F2Collectable.jan21,
    //     pro5F3Collectable.jan21
    // ]
    // export const pro5WithJan21NonCount = [
    //     pro5F1NonCollectable.jan21,
    //     pro5F2NonCollectable.jan21,
    //     pro5F3NonCollectable.jan21
    // ]
    // export const pro5WithJan21Claim = [
    //     pro5F1ClaimCount.jan21,
    //     pro5F2ClaimCount.jan21,
    //     pro5F3ClaimCount.jan21
    // ]
    // export const pro5WithJan21PerVisit = [
    //     pro5F1PerVisit.jan21,
    //     pro5F2PerVisit.jan21,
    //     pro5F3PerVisit.jan21
    // ]
    // // feb 21
    // export const pro5WithFeb21Charges = [
    //     pro5F1Charge.feb21,
    //     pro5F2Charge.feb21,
    //     pro5F3Charge.feb21
    // ]
    // export const pro5WithFeb21Pay = [
    //     pro5F1Payment.feb21,
    //     pro5F2Payment.feb21,
    //     pro5F3Payment.feb21
    // ]
    // export const pro5WithFeb21Count = [
    //     pro5F1Collectable.feb21,
    //     pro5F2Collectable.feb21,
    //     pro5F3Collectable.feb21
    // ]
    // export const pro5WithFeb21NonCount = [
    //     pro5F1NonCollectable.feb21,
    //     pro5F2NonCollectable.feb21,
    //     pro5F3NonCollectable.feb21
    // ]
    // export const pro5WithFeb21Claim = [
    //     pro5F1ClaimCount.feb21,
    //     pro5F2ClaimCount.feb21,
    //     pro5F3ClaimCount.feb21
    // ]
    // export const pro5WithFeb21PerVisit = [
    //     pro5F1PerVisit.feb21,
    //     pro5F2PerVisit.feb21,
    //     pro5F3PerVisit.feb21
    // ]
    // // mar 21
    // export const pro5WithMar21Charges = [
    //     pro5F1Charge.mar21,
    //     pro5F2Charge.mar21,
    //     pro5F3Charge.mar21
    // ]
    // export const pro5WithMar21Pay = [
    //     pro5F1Payment.mar21,
    //     pro5F2Payment.mar21,
    //     pro5F3Payment.mar21
    // ]
    // export const pro5WithMar21Count = [
    //     pro5F1Collectable.mar21,
    //     pro5F2Collectable.mar21,
    //     pro5F3Collectable.mar21
    // ]
    // export const pro5WithMar21NonCount = [
    //     pro5F1NonCollectable.mar21,
    //     pro5F2NonCollectable.mar21,
    //     pro5F3NonCollectable.mar21
    // ]
    // export const pro5WithMar21Claim = [
    //     pro5F1ClaimCount.mar21,
    //     pro5F2ClaimCount.mar21,
    //     pro5F3ClaimCount.mar21
    // ]
    // export const pro5WithMar21PerVisit = [
    //     pro5F1PerVisit.mar21,
    //     pro5F2PerVisit.mar21,
    //     pro5F3PerVisit.mar21
    // ]
    // // april 21
    // export const pro5WithApr21Charges = [
    //     pro5F1Charge.apr21,
    //     pro5F2Charge.apr21,
    //     pro5F3Charge.apr21
    // ]
    // export const pro5WithApr21Pay = [
    //     pro5F1Payment.apr21,
    //     pro5F2Payment.apr21,
    //     pro5F3Payment.apr21
    // ]
    // export const pro5WithApr21Count = [
    //     pro5F1Collectable.apr21,
    //     pro5F2Collectable.apr21,
    //     pro5F3Collectable.apr21
    // ]
    // export const pro5WithApr21NonCount = [
    //     pro5F1NonCollectable.apr21,
    //     pro5F2NonCollectable.apr21,
    //     pro5F3NonCollectable.apr21
    // ]
    // export const pro5WithApr21Claim = [
    //     pro5F1ClaimCount.apr21,
    //     pro5F2ClaimCount.apr21,
    //     pro5F3ClaimCount.apr21
    // ]
    // export const pro5WithApr21PerVisit = [
    //     pro5F1PerVisit.apr21,
    //     pro5F2PerVisit.apr21,
    //     pro5F3PerVisit.apr21
    // ]
    // // may 21
    // export const pro5WithMay21Charges = [
    //     pro5F1Charge.may21,
    //     pro5F2Charge.may21,
    //     pro5F3Charge.may21
    // ]
    // export const pro5WithMay21Pay = [
    //     pro5F1Payment.may21,
    //     pro5F2Payment.may21,
    //     pro5F3Payment.may21
    // ]
    // export const pro5WithMay21Count = [
    //     pro5F1Collectable.may21,
    //     pro5F2Collectable.may21,
    //     pro5F3Collectable.may21
    // ]
    // export const pro5WithMay21NonCount = [
    //     pro5F1NonCollectable.may21,
    //     pro5F2NonCollectable.may21,
    //     pro5F3NonCollectable.may21
    // ]
    // export const pro5WithMay21Claim = [
    //     pro5F1ClaimCount.may21,
    //     pro5F2ClaimCount.may21,
    //     pro5F3ClaimCount.may21
    // ]
    // export const pro5WithMay21PerVisit = [
    //     pro5F1PerVisit.may21,
    //     pro5F2PerVisit.may21,
    //     pro5F3PerVisit.may21
    // ]
    // // jun 21
    // export const pro5WithJun21Charges = [
    //     pro5F1Charge.jun21,
    //     pro5F2Charge.jun21,
    //     pro5F3Charge.jun21
    // ]
    // export const pro5WithJun21Pay = [
    //     pro5F1Payment.jun21,
    //     pro5F2Payment.jun21,
    //     pro5F3Payment.jun21
    // ]
    // export const pro5WithJun21Count = [
    //     pro5F1Collectable.jun21,
    //     pro5F2Collectable.jun21,
    //     pro5F3Collectable.jun21
    // ]
    // export const pro5WithJun21NonCount = [
    //     pro5F1NonCollectable.jun21,
    //     pro5F2NonCollectable.jun21,
    //     pro5F3NonCollectable.jun21
    // ]
    // export const pro5WithJun21Claim = [
    //     pro5F1ClaimCount.jun21,
    //     pro5F2ClaimCount.jun21,
    //     pro5F3ClaimCount.jun21
    // ]
    // export const pro5WithJun21PerVisit = [
    //     pro5F1PerVisit.jun21,
    //     pro5F2PerVisit.jun21,
    //     pro5F3PerVisit.jun21
    // ]
    // // jul 21
    // export const pro5WithJul21Charges = [
    //     pro5F1Charge.jul21,
    //     pro5F2Charge.jul21,
    //     pro5F3Charge.jul21
    // ]
    // export const pro5WithJul21Pay = [
    //     pro5F1Payment.jul21,
    //     pro5F2Payment.jul21,
    //     pro5F3Payment.jul21
    // ]
    // export const pro5WithJul21Count = [
    //     pro5F1Collectable.jul21,
    //     pro5F2Collectable.jul21,
    //     pro5F3Collectable.jul21
    // ]
    // export const pro5WithJul21NonCount = [
    //     pro5F1NonCollectable.jul21,
    //     pro5F2NonCollectable.jul21,
    //     pro5F3NonCollectable.jul21
    // ]
    // export const pro5WithJul21Claim = [
    //     pro5F1ClaimCount.jul21,
    //     pro5F2ClaimCount.jul21,
    //     pro5F3ClaimCount.jul21
    // ]
    // export const pro5WithJul21PerVisit = [
    //     pro5F1PerVisit.jul21,
    //     pro5F2PerVisit.jul21,
    //     pro5F3PerVisit.jul21
    // ]
    // // aug 21
    // export const pro5WithAug21Charges = [
    //     pro5F1Charge.aug21,
    //     pro5F2Charge.aug21,
    //     pro5F3Charge.aug21
    // ]
    // export const pro5WithAug21Pay = [
    //     pro5F1Payment.aug21,
    //     pro5F2Payment.aug21,
    //     pro5F3Payment.aug21
    // ]
    // export const pro5WithAug21Count = [
    //     pro5F1Collectable.aug21,
    //     pro5F2Collectable.aug21,
    //     pro5F3Collectable.aug21
    // ]
    // export const pro5WithAug21NonCount = [
    //     pro5F1NonCollectable.aug21,
    //     pro5F2NonCollectable.aug21,
    //     pro5F3NonCollectable.aug21
    // ]
    // export const pro5WithAug21Claim = [
    //     pro5F1ClaimCount.aug21,
    //     pro5F2ClaimCount.aug21,
    //     pro5F3ClaimCount.aug21
    // ]
    // export const pro5WithAug21PerVisit = [
    //     pro5F1PerVisit.aug21,
    //     pro5F2PerVisit.aug21,
    //     pro5F3PerVisit.aug21
    // ]
    // // sep 21
    // export const pro5WithSep21Charges = [
    //     pro5F1Charge.sep21,
    //     pro5F2Charge.sep21,
    //     pro5F3Charge.sep21
    // ]
    // export const pro5WithSep21Pay = [
    //     pro5F1Payment.sep21,
    //     pro5F2Payment.sep21,
    //     pro5F3Payment.sep21
    // ]
    // export const pro5WithSep21Count = [
    //     pro5F1Collectable.sep21,
    //     pro5F2Collectable.sep21,
    //     pro5F3Collectable.sep21
    // ]
    // export const pro5WithSep21NonCount = [
    //     pro5F1NonCollectable.sep21,
    //     pro5F2NonCollectable.sep21,
    //     pro5F3NonCollectable.sep21
    // ]
    // export const pro5WithSep21Claim = [
    //     pro5F1ClaimCount.sep21,
    //     pro5F2ClaimCount.sep21,
    //     pro5F3ClaimCount.sep21
    // ]
    // export const pro5WithSep21PerVisit = [
    //     pro5F1PerVisit.sep21,
    //     pro5F2PerVisit.sep21,
    //     pro5F3PerVisit.sep21
    // ]
    // // oct 21
    // export const pro5WithOct21Charges = [
    //     pro5F1Charge.oct21,
    //     pro5F2Charge.oct21,
    //     pro5F3Charge.oct21
    // ]
    // export const pro5WithOct21Pay = [
    //     pro5F1Payment.oct21,
    //     pro5F2Payment.oct21,
    //     pro5F3Payment.oct21
    // ]
    // export const pro5WithOct21Count = [
    //     pro5F1Collectable.oct21,
    //     pro5F2Collectable.oct21,
    //     pro5F3Collectable.oct21
    // ]
    // export const pro5WithOct21NonCount = [
    //     pro5F1NonCollectable.oct21,
    //     pro5F2NonCollectable.oct21,
    //     pro5F3NonCollectable.oct21
    // ]
    // export const pro5WithOct21Claim = [
    //     pro5F1ClaimCount.oct21,
    //     pro5F2ClaimCount.oct21,
    //     pro5F3ClaimCount.oct21
    // ]
    // export const pro5WithOct21PerVisit = [
    //     pro5F1PerVisit.oct21,
    //     pro5F2PerVisit.oct21,
    //     pro5F3PerVisit.oct21
    // ]
    // // nov 21
    // export const pro5WithNov21Charges = [
    //     pro5F1Charge.nov21,
    //     pro5F2Charge.nov21,
    //     pro5F3Charge.nov21
    // ]
    // export const pro5WithNov21Pay = [
    //     pro5F1Payment.nov21,
    //     pro5F2Payment.nov21,
    //     pro5F3Payment.nov21
    // ]
    // export const pro5WithNov21Count = [
    //     pro5F1Collectable.nov21,
    //     pro5F2Collectable.nov21,
    //     pro5F3Collectable.nov21
    // ]
    // export const pro5WithNov21NonCount = [
    //     pro5F1NonCollectable.nov21,
    //     pro5F2NonCollectable.nov21,
    //     pro5F3NonCollectable.nov21
    // ]
    // export const pro5WithNov21Claim = [
    //     pro5F1ClaimCount.nov21,
    //     pro5F2ClaimCount.nov21,
    //     pro5F3ClaimCount.nov21
    // ]
    // export const pro5WithNov21PerVisit = [
    //     pro5F1PerVisit.nov21,
    //     pro5F2PerVisit.nov21,
    //     pro5F3PerVisit.nov21
    // ]
    // // dec 21
    // export const pro5WithDec21Charges = [
    //     pro5F1Charge.dec21,
    //     pro5F2Charge.dec21,
    //     pro5F3Charge.dec21
    // ]
    // export const pro5WithDec21Pay = [
    //     pro5F1Payment.dec21,
    //     pro5F2Payment.dec21,
    //     pro5F3Payment.dec21
    // ]
    // export const pro5WithDec21Count = [
    //     pro5F1Collectable.dec21,
    //     pro5F2Collectable.dec21,
    //     pro5F3Collectable.dec21
    // ]
    // export const pro5WithDec21NonCount = [
    //     pro5F1NonCollectable.dec21,
    //     pro5F2NonCollectable.dec21,
    //     pro5F3NonCollectable.dec21
    // ]
    // export const pro5WithDec21Claim = [
    //     pro5F1ClaimCount.dec21,
    //     pro5F2ClaimCount.dec21,
    //     pro5F3ClaimCount.dec21
    // ]
    // export const pro5WithDec21PerVisit = [
    //     pro5F1PerVisit.dec21,
    //     pro5F2PerVisit.dec21,
    //     pro5F3PerVisit.dec21
    // ]
    
    // // provider-5
    // // jan 22
    // export const pro5WithJan22Charges = [
    //     pro5F1Charge.jan22,
    //     pro5F2Charge.jan22,
    //     pro5F3Charge.jan22
    // ]
    // export const pro5WithJan22Pay = [
    //     pro5F1Payment.jan22,
    //     pro5F2Payment.jan22,
    //     pro5F3Payment.jan22
    // ]
    // export const pro5WithJan22Count = [
    //     pro5F1Collectable.jan22,
    //     pro5F2Collectable.jan22,
    //     pro5F3Collectable.jan22
    // ]
    // export const pro5WithJan22NonCount = [
    //     pro5F1NonCollectable.jan22,
    //     pro5F2NonCollectable.jan22,
    //     pro5F3NonCollectable.jan22
    // ]
    // export const pro5WithJan22Claim = [
    //     pro5F1ClaimCount.jan22,
    //     pro5F2ClaimCount.jan22,
    //     pro5F3ClaimCount.jan22
    // ]
    // export const pro5WithJan22PerVisit = [
    //     pro5F1PerVisit.jan22,
    //     pro5F2PerVisit.jan22,
    //     pro5F3PerVisit.jan22
    // ]
    // // feb 22
    // export const pro5WithFeb22Charges = [
    //     pro5F1Charge.feb22,
    //     pro5F2Charge.feb22,
    //     pro5F3Charge.feb22
    // ]
    // export const pro5WithFeb22Pay = [
    //     pro5F1Payment.feb22,
    //     pro5F2Payment.feb22,
    //     pro5F3Payment.feb22
    // ]
    // export const pro5WithFeb22Count = [
    //     pro5F1Collectable.feb22,
    //     pro5F2Collectable.feb22,
    //     pro5F3Collectable.feb22
    // ]
    // export const pro5WithFeb22NonCount = [
    //     pro5F1NonCollectable.feb22,
    //     pro5F2NonCollectable.feb22,
    //     pro5F3NonCollectable.feb22
    // ]
    // export const pro5WithFeb22Claim = [
    //     pro5F1ClaimCount.feb22,
    //     pro5F2ClaimCount.feb22,
    //     pro5F3ClaimCount.feb22
    // ]
    // export const pro5WithFeb22PerVisit = [
    //     pro5F1PerVisit.feb22,
    //     pro5F2PerVisit.feb22,
    //     pro5F3PerVisit.feb22
    // ]
    // // mar 22
    // export const pro5WithMar22Charges = [
    //     pro5F1Charge.mar22,
    //     pro5F2Charge.mar22,
    //     pro5F3Charge.mar22
    // ]
    // export const pro5WithMar22Pay = [
    //     pro5F1Payment.mar22,
    //     pro5F2Payment.mar22,
    //     pro5F3Payment.mar22
    // ]
    // export const pro5WithMar22Count = [
    //     pro5F1Collectable.mar22,
    //     pro5F2Collectable.mar22,
    //     pro5F3Collectable.mar22
    // ]
    // export const pro5WithMar22NonCount = [
    //     pro5F1NonCollectable.mar22,
    //     pro5F2NonCollectable.mar22,
    //     pro5F3NonCollectable.mar22
    // ]
    // export const pro5WithMar22Claim = [
    //     pro5F1ClaimCount.mar22,
    //     pro5F2ClaimCount.mar22,
    //     pro5F3ClaimCount.mar22
    // ]
    // export const pro5WithMar22PerVisit = [
    //     pro5F1PerVisit.mar22,
    //     pro5F2PerVisit.mar22,
    //     pro5F3PerVisit.mar22
    // ]
    // // april 22
    // export const pro5WithApr22Charges = [
    //     pro5F1Charge.apr22,
    //     pro5F2Charge.apr22,
    //     pro5F3Charge.apr22
    // ]
    // export const pro5WithApr22Pay = [
    //     pro5F1Payment.apr22,
    //     pro5F2Payment.apr22,
    //     pro5F3Payment.apr22
    // ]
    // export const pro5WithApr22Count = [
    //     pro5F1Collectable.apr22,
    //     pro5F2Collectable.apr22,
    //     pro5F3Collectable.apr22
    // ]
    // export const pro5WithApr22NonCount = [
    //     pro5F1NonCollectable.apr22,
    //     pro5F2NonCollectable.apr22,
    //     pro5F3NonCollectable.apr22
    // ]
    // export const pro5WithApr22Claim = [
    //     pro5F1ClaimCount.apr22,
    //     pro5F2ClaimCount.apr22,
    //     pro5F3ClaimCount.apr22
    // ]
    // export const pro5WithApr22PerVisit = [
    //     pro5F1PerVisit.apr22,
    //     pro5F2PerVisit.apr22,
    //     pro5F3PerVisit.apr22
    // ]
    // // may 22
    // export const pro5WithMay22Charges = [
    //     pro5F1Charge.may22,
    //     pro5F2Charge.may22,
    //     pro5F3Charge.may22
    // ]
    // export const pro5WithMay22Pay = [
    //     pro5F1Payment.may22,
    //     pro5F2Payment.may22,
    //     pro5F3Payment.may22
    // ]
    // export const pro5WithMay22Count = [
    //     pro5F1Collectable.may22,
    //     pro5F2Collectable.may22,
    //     pro5F3Collectable.may22
    // ]
    // export const pro5WithMay22NonCount = [
    //     pro5F1NonCollectable.may22,
    //     pro5F2NonCollectable.may22,
    //     pro5F3NonCollectable.may22
    // ]
    // export const pro5WithMay22Claim = [
    //     pro5F1ClaimCount.may22,
    //     pro5F2ClaimCount.may22,
    //     pro5F3ClaimCount.may22
    // ]
    // export const pro5WithMay22PerVisit = [
    //     pro5F1PerVisit.may22,
    //     pro5F2PerVisit.may22,
    //     pro5F3PerVisit.may22
    // ]
    // // jun 22
    // export const pro5WithJun22Charges = [
    //     pro5F1Charge.jun22,
    //     pro5F2Charge.jun22,
    //     pro5F3Charge.jun22
    // ]
    // export const pro5WithJun22Pay = [
    //     pro5F1Payment.jun22,
    //     pro5F2Payment.jun22,
    //     pro5F3Payment.jun22
    // ]
    // export const pro5WithJun22Count = [
    //     pro5F1Collectable.jun22,
    //     pro5F2Collectable.jun22,
    //     pro5F3Collectable.jun22
    // ]
    // export const pro5WithJun22NonCount = [
    //     pro5F1NonCollectable.jun22,
    //     pro5F2NonCollectable.jun22,
    //     pro5F3NonCollectable.jun22
    // ]
    // export const pro5WithJun22Claim = [
    //     pro5F1ClaimCount.jun22,
    //     pro5F2ClaimCount.jun22,
    //     pro5F3ClaimCount.jun22
    // ]
    // export const pro5WithJun22PerVisit = [
    //     pro5F1PerVisit.jun22,
    //     pro5F2PerVisit.jun22,
    //     pro5F3PerVisit.jun22
    // ]
    // // jul 22
    // export const pro5WithJul22Charges = [
    //     pro5F1Charge.jul22,
    //     pro5F2Charge.jul22,
    //     pro5F3Charge.jul22
    // ]
    // export const pro5WithJul22Pay = [
    //     pro5F1Payment.jul22,
    //     pro5F2Payment.jul22,
    //     pro5F3Payment.jul22
    // ]
    // export const pro5WithJul22Count = [
    //     pro5F1Collectable.jul22,
    //     pro5F2Collectable.jul22,
    //     pro5F3Collectable.jul22
    // ]
    // export const pro5WithJul22NonCount = [
    //     pro5F1NonCollectable.jul22,
    //     pro5F2NonCollectable.jul22,
    //     pro5F3NonCollectable.jul22
    // ]
    // export const pro5WithJul22Claim = [
    //     pro5F1ClaimCount.jul22,
    //     pro5F2ClaimCount.jul22,
    //     pro5F3ClaimCount.jul22
    // ]
    // export const pro5WithJul22PerVisit = [
    //     pro5F1PerVisit.jul22,
    //     pro5F2PerVisit.jul22,
    //     pro5F3PerVisit.jul22
    // ]
    // // aug 22
    // export const pro5WithAug22Charges = [
    //     pro5F1Charge.aug22,
    //     pro5F2Charge.aug22,
    //     pro5F3Charge.aug22
    // ]
    // export const pro5WithAug22Pay = [
    //     pro5F1Payment.aug22,
    //     pro5F2Payment.aug22,
    //     pro5F3Payment.aug22
    // ]
    // export const pro5WithAug22Count = [
    //     pro5F1Collectable.aug22,
    //     pro5F2Collectable.aug22,
    //     pro5F3Collectable.aug22
    // ]
    // export const pro5WithAug22NonCount = [
    //     pro5F1NonCollectable.aug22,
    //     pro5F2NonCollectable.aug22,
    //     pro5F3NonCollectable.aug22
    // ]
    // export const pro5WithAug22Claim = [
    //     pro5F1ClaimCount.aug22,
    //     pro5F2ClaimCount.aug22,
    //     pro5F3ClaimCount.aug22
    // ]
    // export const pro5WithAug22PerVisit = [
    //     pro5F1PerVisit.aug22,
    //     pro5F2PerVisit.aug22,
    //     pro5F3PerVisit.aug22
    // ]
    // // sep 22
    // export const pro5WithSep22Charges = [
    //     pro5F1Charge.sep22,
    //     pro5F2Charge.sep22,
    //     pro5F3Charge.sep22
    // ]
    // export const pro5WithSep22Pay = [
    //     pro5F1Payment.sep22,
    //     pro5F2Payment.sep22,
    //     pro5F3Payment.sep22
    // ]
    // export const pro5WithSep22Count = [
    //     pro5F1Collectable.sep22,
    //     pro5F2Collectable.sep22,
    //     pro5F3Collectable.sep22
    // ]
    // export const pro5WithSep22NonCount = [
    //     pro5F1NonCollectable.sep22,
    //     pro5F2NonCollectable.sep22,
    //     pro5F3NonCollectable.sep22
    // ]
    // export const pro5WithSep22Claim = [
    //     pro5F1ClaimCount.sep22,
    //     pro5F2ClaimCount.sep22,
    //     pro5F3ClaimCount.sep22
    // ]
    // export const pro5WithSep22PerVisit = [
    //     pro5F1PerVisit.sep22,
    //     pro5F2PerVisit.sep22,
    //     pro5F3PerVisit.sep22
    // ]
    // // oct 22
    // export const pro5WithOct22Charges = [
    //     pro5F1Charge.oct22,
    //     pro5F2Charge.oct22,
    //     pro5F3Charge.oct22
    // ]
    // export const pro5WithOct22Pay = [
    //     pro5F1Payment.oct22,
    //     pro5F2Payment.oct22,
    //     pro5F3Payment.oct22
    // ]
    // export const pro5WithOct22Count = [
    //     pro5F1Collectable.oct22,
    //     pro5F2Collectable.oct22,
    //     pro5F3Collectable.oct22
    // ]
    // export const pro5WithOct22NonCount = [
    //     pro5F1NonCollectable.oct22,
    //     pro5F2NonCollectable.oct22,
    //     pro5F3NonCollectable.oct22
    // ]
    // export const pro5WithOct22Claim = [
    //     pro5F1ClaimCount.oct22,
    //     pro5F2ClaimCount.oct22,
    //     pro5F3ClaimCount.oct22
    // ]
    // export const pro5WithOct22PerVisit = [
    //     pro5F1PerVisit.oct22,
    //     pro5F2PerVisit.oct22,
    //     pro5F3PerVisit.oct22
    // ]
    // // nov 22
    // export const pro5WithNov22Charges = [
    //     pro5F1Charge.nov22,
    //     pro5F2Charge.nov22,
    //     pro5F3Charge.nov22
    // ]
    // export const pro5WithNov22Pay = [
    //     pro5F1Payment.nov22,
    //     pro5F2Payment.nov22,
    //     pro5F3Payment.nov22
    // ]
    // export const pro5WithNov22Count = [
    //     pro5F1Collectable.nov22,
    //     pro5F2Collectable.nov22,
    //     pro5F3Collectable.nov22
    // ]
    // export const pro5WithNov22NonCount = [
    //     pro5F1NonCollectable.nov22,
    //     pro5F2NonCollectable.nov22,
    //     pro5F3NonCollectable.nov22
    // ]
    // export const pro5WithNov22Claim = [
    //     pro5F1ClaimCount.nov22,
    //     pro5F2ClaimCount.nov22,
    //     pro5F3ClaimCount.nov22
    // ]
    // export const pro5WithNov22PerVisit = [
    //     pro5F1PerVisit.nov22,
    //     pro5F2PerVisit.nov22,
    //     pro5F3PerVisit.nov22
    // ]
    // // dec 22
    // export const pro5WithDec22Charges = [
    //     pro5F1Charge.dec22,
    //     pro5F2Charge.dec22,
    //     pro5F3Charge.dec22
    // ]
    // export const pro5WithDec22Pay = [
    //     pro5F1Payment.dec22,
    //     pro5F2Payment.dec22,
    //     pro5F3Payment.dec22
    // ]
    // export const pro5WithDec22Count = [
    //     pro5F1Collectable.dec22,
    //     pro5F2Collectable.dec22,
    //     pro5F3Collectable.dec22
    // ]
    // export const pro5WithDec22NonCount = [
    //     pro5F1NonCollectable.dec22,
    //     pro5F2NonCollectable.dec22,
    //     pro5F3NonCollectable.dec22
    // ]
    // export const pro5WithDec22Claim = [
    //     pro5F1ClaimCount.dec22,
    //     pro5F2ClaimCount.dec22,
    //     pro5F3ClaimCount.dec22
    // ]
    // export const pro5WithDec22PerVisit = [
    //     pro5F1PerVisit.dec22,
    //     pro5F2PerVisit.dec22,
    //     pro5F3PerVisit.dec22
    // ]
    
    // // provider-5
    // // jan 23
    // export const pro5WithJan23Charges = [
    //     pro5F1Charge.jan23,
    //     pro5F2Charge.jan23,
    //     pro5F3Charge.jan23
    // ]
    // export const pro5WithJan23Pay = [
    //     pro5F1Payment.jan23,
    //     pro5F2Payment.jan23,
    //     pro5F3Payment.jan23
    // ]
    // export const pro5WithJan23Count = [
    //     pro5F1Collectable.jan23,
    //     pro5F2Collectable.jan23,
    //     pro5F3Collectable.jan23
    // ]
    // export const pro5WithJan23NonCount = [
    //     pro5F1NonCollectable.jan23,
    //     pro5F2NonCollectable.jan23,
    //     pro5F3NonCollectable.jan23
    // ]
    // export const pro5WithJan23Claim = [
    //     pro5F1ClaimCount.jan23,
    //     pro5F2ClaimCount.jan23,
    //     pro5F3ClaimCount.jan23
    // ]
    // export const pro5WithJan23PerVisit = [
    //     pro5F1PerVisit.jan23,
    //     pro5F2PerVisit.jan23,
    //     pro5F3PerVisit.jan23
    // ]
    // // feb 23
    // export const pro5WithFeb23Charges = [
    //     pro5F1Charge.feb23,
    //     pro5F2Charge.feb23,
    //     pro5F3Charge.feb23
    // ]
    // export const pro5WithFeb23Pay = [
    //     pro5F1Payment.feb23,
    //     pro5F2Payment.feb23,
    //     pro5F3Payment.feb23
    // ]
    // export const pro5WithFeb23Count = [
    //     pro5F1Collectable.feb23,
    //     pro5F2Collectable.feb23,
    //     pro5F3Collectable.feb23
    // ]
    // export const pro5WithFeb23NonCount = [
    //     pro5F1NonCollectable.feb23,
    //     pro5F2NonCollectable.feb23,
    //     pro5F3NonCollectable.feb23
    // ]
    // export const pro5WithFeb23Claim = [
    //     pro5F1ClaimCount.feb23,
    //     pro5F2ClaimCount.feb23,
    //     pro5F3ClaimCount.feb23
    // ]
    // export const pro5WithFeb23PerVisit = [
    //     pro5F1PerVisit.feb23,
    //     pro5F2PerVisit.feb23,
    //     pro5F3PerVisit.feb23
    // ]
    // // mar 23
    // export const pro5WithMar23Charges = [
    //     pro5F1Charge.mar23,
    //     pro5F2Charge.mar23,
    //     pro5F3Charge.mar23
    // ]
    // export const pro5WithMar23Pay = [
    //     pro5F1Payment.mar23,
    //     pro5F2Payment.mar23,
    //     pro5F3Payment.mar23
    // ]
    // export const pro5WithMar23Count = [
    //     pro5F1Collectable.mar23,
    //     pro5F2Collectable.mar23,
    //     pro5F3Collectable.mar23
    // ]
    // export const pro5WithMar23NonCount = [
    //     pro5F1NonCollectable.mar23,
    //     pro5F2NonCollectable.mar23,
    //     pro5F3NonCollectable.mar23
    // ]
    // export const pro5WithMar23Claim = [
    //     pro5F1ClaimCount.mar23,
    //     pro5F2ClaimCount.mar23,
    //     pro5F3ClaimCount.mar23
    // ]
    // export const pro5WithMar23PerVisit = [
    //     pro5F1PerVisit.mar23,
    //     pro5F2PerVisit.mar23,
    //     pro5F3PerVisit.mar23
    // ]
    // // april 23
    // export const pro5WithApr23Charges = [
    //     pro5F1Charge.apr23,
    //     pro5F2Charge.apr23,
    //     pro5F3Charge.apr23
    // ]
    // export const pro5WithApr23Pay = [
    //     pro5F1Payment.apr23,
    //     pro5F2Payment.apr23,
    //     pro5F3Payment.apr23
    // ]
    // export const pro5WithApr23Count = [
    //     pro5F1Collectable.apr23,
    //     pro5F2Collectable.apr23,
    //     pro5F3Collectable.apr23
    // ]
    // export const pro5WithApr23NonCount = [
    //     pro5F1NonCollectable.apr23,
    //     pro5F2NonCollectable.apr23,
    //     pro5F3NonCollectable.apr23
    // ]
    // export const pro5WithApr23Claim = [
    //     pro5F1ClaimCount.apr23,
    //     pro5F2ClaimCount.apr23,
    //     pro5F3ClaimCount.apr23
    // ]
    // export const pro5WithApr23PerVisit = [
    //     pro5F1PerVisit.apr23,
    //     pro5F2PerVisit.apr23,
    //     pro5F3PerVisit.apr23
    // ]
    // // may 23
    // export const pro5WithMay23Charges = [
    //     pro5F1Charge.may23,
    //     pro5F2Charge.may23,
    //     pro5F3Charge.may23
    // ]
    // export const pro5WithMay23Pay = [
    //     pro5F1Payment.may23,
    //     pro5F2Payment.may23,
    //     pro5F3Payment.may23
    // ]
    // export const pro5WithMay23Count = [
    //     pro5F1Collectable.may23,
    //     pro5F2Collectable.may23,
    //     pro5F3Collectable.may23
    // ]
    // export const pro5WithMay23NonCount = [
    //     pro5F1NonCollectable.may23,
    //     pro5F2NonCollectable.may23,
    //     pro5F3NonCollectable.may23
    // ]
    // export const pro5WithMay23Claim = [
    //     pro5F1ClaimCount.may23,
    //     pro5F2ClaimCount.may23,
    //     pro5F3ClaimCount.may23
    // ]
    // export const pro5WithMay23PerVisit = [
    //     pro5F1PerVisit.may23,
    //     pro5F2PerVisit.may23,
    //     pro5F3PerVisit.may23
    // ]
    // // jun 23
    // export const pro5WithJun23Charges = [
    //     pro5F1Charge.jun23,
    //     pro5F2Charge.jun23,
    //     pro5F3Charge.jun23
    // ]
    // export const pro5WithJun23Pay = [
    //     pro5F1Payment.jun23,
    //     pro5F2Payment.jun23,
    //     pro5F3Payment.jun23
    // ]
    // export const pro5WithJun23Count = [
    //     pro5F1Collectable.jun23,
    //     pro5F2Collectable.jun23,
    //     pro5F3Collectable.jun23
    // ]
    // export const pro5WithJun23NonCount = [
    //     pro5F1NonCollectable.jun23,
    //     pro5F2NonCollectable.jun23,
    //     pro5F3NonCollectable.jun23
    // ]
    // export const pro5WithJun23Claim = [
    //     pro5F1ClaimCount.jun23,
    //     pro5F2ClaimCount.jun23,
    //     pro5F3ClaimCount.jun23
    // ]
    // export const pro5WithJun23PerVisit = [
    //     pro5F1PerVisit.jun23,
    //     pro5F2PerVisit.jun23,
    //     pro5F3PerVisit.jun23
    // ]
    // // jul 23
    // export const pro5WithJul23Charges = [
    //     pro5F1Charge.jul23,
    //     pro5F2Charge.jul23,
    //     pro5F3Charge.jul23
    // ]
    // export const pro5WithJul23Pay = [
    //     pro5F1Payment.jul23,
    //     pro5F2Payment.jul23,
    //     pro5F3Payment.jul23
    // ]
    // export const pro5WithJul23Count = [
    //     pro5F1Collectable.jul23,
    //     pro5F2Collectable.jul23,
    //     pro5F3Collectable.jul23
    // ]
    // export const pro5WithJul23NonCount = [
    //     pro5F1NonCollectable.jul23,
    //     pro5F2NonCollectable.jul23,
    //     pro5F3NonCollectable.jul23
    // ]
    // export const pro5WithJul23Claim = [
    //     pro5F1ClaimCount.jul23,
    //     pro5F2ClaimCount.jul23,
    //     pro5F3ClaimCount.jul23
    // ]
    // export const pro5WithJul23PerVisit = [
    //     pro5F1PerVisit.jul23,
    //     pro5F2PerVisit.jul23,
    //     pro5F3PerVisit.jul23
    // ]
    // // aug 23
    // export const pro5WithAug23Charges = [
    //     pro5F1Charge.aug23,
    //     pro5F2Charge.aug23,
    //     pro5F3Charge.aug23
    // ]
    // export const pro5WithAug23Pay = [
    //     pro5F1Payment.aug23,
    //     pro5F2Payment.aug23,
    //     pro5F3Payment.aug23
    // ]
    // export const pro5WithAug23Count = [
    //     pro5F1Collectable.aug23,
    //     pro5F2Collectable.aug23,
    //     pro5F3Collectable.aug23
    // ]
    // export const pro5WithAug23NonCount = [
    //     pro5F1NonCollectable.aug23,
    //     pro5F2NonCollectable.aug23,
    //     pro5F3NonCollectable.aug23
    // ]
    // export const pro5WithAug23Claim = [
    //     pro5F1ClaimCount.aug23,
    //     pro5F2ClaimCount.aug23,
    //     pro5F3ClaimCount.aug23
    // ]
    // export const pro5WithAug23PerVisit = [
    //     pro5F1PerVisit.aug23,
    //     pro5F2PerVisit.aug23,
    //     pro5F3PerVisit.aug23
    // ]
    // // sep 23
    // export const pro5WithSep23Charges = [
    //     pro5F1Charge.sep23,
    //     pro5F2Charge.sep23,
    //     pro5F3Charge.sep23
    // ]
    // export const pro5WithSep23Pay = [
    //     pro5F1Payment.sep23,
    //     pro5F2Payment.sep23,
    //     pro5F3Payment.sep23
    // ]
    // export const pro5WithSep23Count = [
    //     pro5F1Collectable.sep23,
    //     pro5F2Collectable.sep23,
    //     pro5F3Collectable.sep23
    // ]
    // export const pro5WithSep23NonCount = [
    //     pro5F1NonCollectable.sep23,
    //     pro5F2NonCollectable.sep23,
    //     pro5F3NonCollectable.sep23
    // ]
    // export const pro5WithSep23Claim = [
    //     pro5F1ClaimCount.sep23,
    //     pro5F2ClaimCount.sep23,
    //     pro5F3ClaimCount.sep23
    // ]
    // export const pro5WithSep23PerVisit = [
    //     pro5F1PerVisit.sep23,
    //     pro5F2PerVisit.sep23,
    //     pro5F3PerVisit.sep23
    // ]
    // // oct 23
    // export const pro5WithOct23Charges = [
    //     pro5F1Charge.oct23,
    //     pro5F2Charge.oct23,
    //     pro5F3Charge.oct23
    // ]
    // export const pro5WithOct23Pay = [
    //     pro5F1Payment.oct23,
    //     pro5F2Payment.oct23,
    //     pro5F3Payment.oct23
    // ]
    // export const pro5WithOct23Count = [
    //     pro5F1Collectable.oct23,
    //     pro5F2Collectable.oct23,
    //     pro5F3Collectable.oct23
    // ]
    // export const pro5WithOct23NonCount = [
    //     pro5F1NonCollectable.oct23,
    //     pro5F2NonCollectable.oct23,
    //     pro5F3NonCollectable.oct23
    // ]
    // export const pro5WithOct23Claim = [
    //     pro5F1ClaimCount.oct23,
    //     pro5F2ClaimCount.oct23,
    //     pro5F3ClaimCount.oct23
    // ]
    // export const pro5WithOct23PerVisit = [
    //     pro5F1PerVisit.oct23,
    //     pro5F2PerVisit.oct23,
    //     pro5F3PerVisit.oct23
    // ]
    // // nov 23
    // export const pro5WithNov23Charges = [
    //     pro5F1Charge.nov23,
    //     pro5F2Charge.nov23,
    //     pro5F3Charge.nov23
    // ]
    // export const pro5WithNov23Pay = [
    //     pro5F1Payment.nov23,
    //     pro5F2Payment.nov23,
    //     pro5F3Payment.nov23
    // ]
    // export const pro5WithNov23Count = [
    //     pro5F1Collectable.nov23,
    //     pro5F2Collectable.nov23,
    //     pro5F3Collectable.nov23
    // ]
    // export const pro5WithNov23NonCount = [
    //     pro5F1NonCollectable.nov23,
    //     pro5F2NonCollectable.nov23,
    //     pro5F3NonCollectable.nov23
    // ]
    // export const pro5WithNov23Claim = [
    //     pro5F1ClaimCount.nov23,
    //     pro5F2ClaimCount.nov23,
    //     pro5F3ClaimCount.nov23
    // ]
    // export const pro5WithNov23PerVisit = [
    //     pro5F1PerVisit.nov23,
    //     pro5F2PerVisit.nov23,
    //     pro5F3PerVisit.nov23
    // ]









